import { useCallback, useContext } from 'react';
import { SportsSeasonContext } from '../cnr/contexts/SportsSeasonContext';
import { getLevelMatchez } from '../cnr/reducers/reducerHelpers/seasonSportsData';
import { _matchLsTypes } from '../cnr/reducers/SportsDataReducer';
import { matchFilterHelpers } from '../elements/matches/MatchFilters';

export const useSportsSeason = () => {

  const sportsSeasonContext = useContext(SportsSeasonContext);
  const { sportsSeason_state } = sportsSeasonContext ?? {};
  const { matches_info, selectedSeason } = sportsSeason_state ?? {};

  const getGroupInfo = useCallback(() => {
    return getMatches_groupInfo(matches_info, null)
  }, [])

  return { getGroupInfo }
}

const getMatches_groupInfo = (matches_info, _deletedTeams) => {

  const { matches } = matches_info ?? {}

  const matches_groupInfo = {
    levelDateGroups: null,
    levelLatestStartDates: null,
    levelLastStartDates: null,
    levelMatches: null,
    matchDateGroups: null,
    matches_combined: null,
    playoffTournaments: null,
  }

  if (matches) {

    const seasonMatches = getAllMatches(matches_info, _deletedTeams)

    const {
      _allMatches,
      _matches,
      _matches_playoffs,
      _dateGroups,
      _levelMatches,
      _levelDateGroups,
      _levelLatestStartDates,
      _levelLastStartDates,
    } = seasonMatches

    const { matchDateKeys, matchDateKeys_count } = matchFilterHelpers.getMatchDateKeys(_dateGroups)

    matches_groupInfo.matches_combined = _allMatches
    matches_groupInfo.matches = _matches
    matches_groupInfo.matches_playoffs = _matches_playoffs
    matches_groupInfo.matchDateGroups = _dateGroups
    matches_groupInfo.matchDateKeys = matchDateKeys
    matches_groupInfo.matchDateKeys_count = matchDateKeys_count
    matches_groupInfo.levelMatches = _levelMatches
    matches_groupInfo.levelKeys = _.difference(_.reverse(_.keys(_levelMatches)), [_matchLsTypes.nonSection, _matchLsTypes.nonLevel, _matchLsTypes.tournament]);
    matches_groupInfo.levelDateGroups = _levelDateGroups
    matches_groupInfo.levelLatestStartDates = _levelLatestStartDates
    matches_groupInfo.levelLastStartDates = _levelLastStartDates
    matches_groupInfo.playoffTournaments = createPlayoffTournaments(_matches_playoffs)
    const { levelSectionDateMatches, scheduleLevelKeys } = getLSMD(_matches)
    matches_groupInfo.levelSectionDateMatches = levelSectionDateMatches
    matches_groupInfo.scheduleLevelKeys = scheduleLevelKeys
    // console.log('matches_groupInfo', matches_groupInfo)
  }

  return matches_groupInfo

}

const getAllMatches = (matchInfo_seasonal, _deletedTeams) => {
  // matches_playoffs is coming from it's own collection 
  const { matches, playoffMatches, playoffScores, scores } = matchInfo_seasonal

  // matchInfo_seasonal => matches, playoffMatches... 

  const dts = _deletedTeams ? _deletedTeams : ['K9IBDjd0zcPUiSB6fjXG']
  const filteredMatches = _.pickBy(matches, match => {
    return !dts.includes(match?.home?.id) && !dts.includes(match?.away?.id);
  });

  if (filteredMatches) {
    let _matches = filteredMatches
    let _allMatches = filteredMatches
    const _playoffMatchesFromMatches = matchFilterHelpers.getPlayoffMatches(_matches)
    const matches_playoffs = !_.isEmpty(playoffMatches) ? playoffMatches : _playoffMatchesFromMatches
    if (!_.isEmpty(matches_playoffs)) { _allMatches = { ...filteredMatches, ...matches_playoffs } }

    const {
      levelMatchDateGroups: _dateGroups,
      levelLatestStartDates: _levelLatestStartDates,
      levelLastStartDates: _levelLastStartDates,
    } = matchFilterHelpers.getLevelMatchDateGroups(_allMatches)

    const { _levelMatches, _levelDateGroups } = getLevelMatchez(_allMatches)

    return {
      _allMatches,
      _matches,
      _matches_playoffs: matches_playoffs,
      _dateGroups,
      _levelMatches,
      _levelDateGroups,
      _levelLatestStartDates,
      _levelLastStartDates
    }
  }
}

const createPlayoffTournaments = (matches_playoffs) => {
  const ts = []
  const levelMatches = _.groupBy(matches_playoffs, 'levels')
  if (levelMatches) {
    Object.keys(levelMatches).forEach(levelKey => {
      ts[levelKey] = { rounds: { playoffs: { itemKey: 'playoffs', pools: {} } } }
      const lm = levelMatches[levelKey]
      const poolMatches = _.groupBy(lm, 'poolKey')
      Object.keys(poolMatches).forEach(poolKey => {
        ts[levelKey].rounds.playoffs.pools[poolKey] = {
          poolKey: poolKey,
          matches: mz(poolMatches[poolKey])
        }
      })
    })
  }
  return ts
}

const getLSMD = (matches) => {

  // Step 1: group by _matchCollectionKey (or 'levels')
  const groupedByLevel = _.groupBy(matches, '_matchCollectionKey');

  // Step 2: for each level, group by startDate and sort chronologically
  const matches_byLevel = _.mapValues(groupedByLevel, (levelGroup) => {

    // group by startDate
    const groupedByDate = _.groupBy(levelGroup, 'startDate');

    // sort the dates
    const sortedByDate = {};
    _.keys(groupedByDate) // using _.keys here
      .sort((a, b) => dateToTimestamp(a) - dateToTimestamp(b))
      .forEach((date) => {
        // group by sections within each date
        const _matches = _.groupBy(groupedByDate[date], 'sections');
        sortedByDate[date] = _matches
      });

    return sortedByDate;
  });


  const matches_added = []

  _.forEach(matches_byLevel, (matches_level, levelKey) => {
    switch (levelKey) {
      case 'Non':
      case 'nonDistrict':
        _.forEach(matches_level, (groupedMatches, groupDateKey) => {
          _.forEach(groupedMatches, (dateMatches, dataMatchKey) => {
            _.forEach(dateMatches, (match) => {
              const { home, away, _itemKey: matchKey } = match;
              const level_home = home?.levels;
              const level_away = away?.levels;

              if (level_home && !_.includes(matches_added, matchKey)) {
                _.update(
                  matches_byLevel,
                  [level_home, groupDateKey, dataMatchKey],
                  (arr = []) => {
                    arr.push(match);
                    return arr;
                  }
                );
                matches_added.push(matchKey)
              }

              if (level_away && !_.includes(matches_added, matchKey)) {
                _.update(
                  matches_byLevel,
                  [level_away, groupDateKey, dataMatchKey],
                  (arr = []) => {
                    arr.push(match);
                    return arr;
                  }
                );
                matches_added.push(matchKey)
              }
            });
          });
        });
    }
  });

  return { levelSectionDateMatches: matches_byLevel, scheduleLevelKeys: _.keys(matches_byLevel) }

}

const dateToTimestamp = (dateStr) => {
  const [month, day, year] = dateStr.split('/').map(Number);
  return new Date(year, month - 1, day).getTime();
};
